import Vue from 'vue'
import Router from 'vue-router'
import DashboardRoutes from "@/routes/DashboardRoutes";
import DeXParaRoutes from "@/routes/DeXParaRoutes";
import FunctionsRoutes from "@/routes/FunctionsRoutes";
import LoincRoutes from "@/routes/LoincRoutes";
import TriggersRoutes from "@/routes/TriggerRoutes";
import TuevsRoutes from "@/routes/TuevsRoutes";
import VnsRoutes from "@/routes/VnsRoutes";
import RndsRoutes from "@/routes/RndsRoutes";
import InteroperaRoutes from "@/routes/InteroperaRoutes";
import CoreCompaniesRoutes from "@/routes/CoreCompaniesRoutes";
import CoreCareUnitsRoutes from "@/routes/CoreCareUnitsRoutes";
import CoreSectorsRoutes from "@/routes/CoreSectorsRoutes";
import {can, hasPerfil} from "@/acl";
import ContainersSupportRoutes from "@/routes/ContainersSupportRoutes";
import Index from "@/pages/Tree/Index";
import AuditRoutes from "@/routes/AuditRoutes";
import ReviewObservationRoutes from "@/routes/ReviewObservationRoutes";


Vue.use(Router)

const RouterServiceProvider = new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    //scrollBehavior () {
    //  return { x: 0, y: 0 };
    //},
    routes: [
        ...DashboardRoutes,
        ...DeXParaRoutes,
        ...FunctionsRoutes,
        ...LoincRoutes,
        ...TriggersRoutes,
        ...TuevsRoutes,
        ...VnsRoutes,
        ...RndsRoutes,
        ...InteroperaRoutes,
        ...CoreCompaniesRoutes,
        ...CoreCareUnitsRoutes,
        ...CoreSectorsRoutes,
        ...ContainersSupportRoutes,
        ...AuditRoutes,
        ...ReviewObservationRoutes,
        {path: '/tree', component: Index},
        {
            path: '/auto_atendimento',
            redirect: {name: 'vaa.index'},
            component: () => import("@/pages/auto_atendimento/Layout"),
            children: [
                {path: '', name: 'vaa.index', component: () => import ("@/pages/auto_atendimento/Index")},
                {path: 'cadastro/:unidadeID?', name: 'vaa.cadastro', component: () => import("@/pages/auto_atendimento/Form")},
                {path: 'orcamentos', name: 'vaa.orcamentos', component: () => import("@/pages/auto_atendimento/Orcamentos")},
                {path: 'qr/:id', name: 'vaa.qr', component: () => import("@/pages/auto_atendimento/QRCode")},
                {path: 'orcamento/:id', name: 'vaa.orcamento.show', component: () => import("@/pages/auto_atendimento/Show")},
            ]
        },
    ]
});

RouterServiceProvider.beforeEach(async ($to, $from, $next) => {
    if (Object.keys($to.meta).length > 0) {
        let allowed = false

        if ($to.meta.perfil) {
            allowed = await hasPerfil($to.meta.perfil)
        }

        if ($to.meta.permission) {
            allowed = await can($to.meta.permission)
        }

        if (allowed) {
            $next()
            return
        } else {
            $next({name: 'Denied'})
            return
        }
    }
    $next()
})

export default RouterServiceProvider;
